import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { type RefObject } from 'react'
import { type CollectionBuilding } from '../../../../../models/peerToPeer/Collection'
import { SurveyType } from '../../../../../models/SurveySchema'
import {
  STARTSurveyDisplay, START_SURVEY_THEME, type STARTSurveyDisplayHandle
} from '../../../../customComponents/survey/STARTSurveyDisplay'
import { styles } from './BuildingsWithPane.styles'

interface Props {
  building: CollectionBuilding
  lastSavedAt?: string
  surveyRef: RefObject<STARTSurveyDisplayHandle>
  loadForm: () => Promise<{ id: SurveyType, content: string, answers?: string } | null>
  saveForm: (answersJson: string) => Promise<void>
}

export const BuildingFormPanel = ({ building, lastSavedAt, surveyRef, loadForm, saveForm }: Props): JSX.Element => {
  const updatedAt = lastSavedAt ?? building.lastUpdatedAt
  const hasCompleter = building.submittedByName != null && building.submittedByName !== ''

  return (
    <Box data-testid='p2pBuildingForm'>
      <Box sx={styles.formHeader}>
        <Box sx={styles.formTitle}>
          <Typography variant='h3'>{building.name}</Typography>
          <Typography variant='body2'>All fields are required unless marked optional.</Typography>
        </Box>
        {(updatedAt != null || hasCompleter) &&
          <Box sx={styles.formMeta}>
            {updatedAt != null &&
              <Typography variant='body2' sx={styles.formMetaLine} data-testid='p2pBuildingLastUpdated'>
                Last updated {dayjs(updatedAt).format('MM/DD/YYYY')}
              </Typography>}
            {hasCompleter &&
              <Typography variant='body2' sx={styles.formMetaLine} data-testid='p2pBuildingSubmittedBy'>
                Completed by {building.submittedByName}{building.submittedAt != null ? ` · ${dayjs(building.submittedAt).format('MM/DD/YYYY')}` : ''}
              </Typography>}
          </Box>}
      </Box>
      <Box sx={styles.formBody}>
        <STARTSurveyDisplay
          ref={surveyRef}
          annualPlanId={0}
          planOrgId={0}
          surveyType={SurveyType.PeerToPeer}
          readOnly={building.isLocked}
          hideNavigation
          loadOverride={loadForm}
          saveOverride={saveForm}
          surveyThemeVariables={START_SURVEY_THEME}
        />
      </Box>
    </Box>
  )
}
